export default __webpack_public_path__ + "static/media/Title_Template.f72e6356.png";